import React from 'react'
import {
  Container,
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Avatar,
  Rating,
} from '@mui/material'
import { Star, Person } from '@mui/icons-material'
import { format, parseISO } from 'date-fns'

const Reviews = ({ companyData }) => {
  const { reviews } = companyData || {}

  const formatDate = dateStr => {
    try {
      return format(parseISO(dateStr), 'MMMM d, yyyy')
    } catch {
      return dateStr
    }
  }

  const averageRating =
    reviews && reviews.length > 0
      ? reviews.reduce((sum, r) => sum + (r.rating || 5), 0) / reviews.length
      : 0

  return (
    <Container maxWidth='lg' sx={{ py: { xs: 6, md: 8 } }}>
      <Box sx={{ mb: 8 }}>
        <Typography variant='h3' gutterBottom color='primary.main' sx={{ mb: 2 }}>
          Customer Reviews
        </Typography>
        {reviews && reviews.length > 0 && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 3 }}>
            <Rating value={averageRating} precision={0.1} readOnly size='large' />
            <Typography variant='h5' color='text.secondary'>
              {averageRating.toFixed(1)} out of 5
            </Typography>
            <Typography variant='body1' color='text.secondary'>
              ({reviews.length} review{reviews.length !== 1 ? 's' : ''})
            </Typography>
          </Box>
        )}
      </Box>

      {reviews && reviews.length > 0 ? (
        <Grid container spacing={4}>
          {reviews.map(review => (
            <Grid item xs={12} key={review.id}>
              <Card>
                <CardContent>
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'flex-start',
                      gap: 2,
                      mb: 2,
                    }}
                  >
                    <Avatar sx={{ bgcolor: 'primary.main' }}>
                      <Person />
                    </Avatar>
                    <Box sx={{ flexGrow: 1 }}>
                      <Box
                        sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'flex-start',
                          mb: 1,
                        }}
                      >
                        <Box>
                          <Typography variant='h6'>
                            {review.customerName}
                          </Typography>
                          {(review.reviewDate || review.createdAt) && (
                            <Typography variant='body2' color='text.secondary'>
                              {formatDate(review.reviewDate || review.createdAt)}
                            </Typography>
                          )}
                          {review.jobTypeName && (
                            <Typography variant='body2' color='primary.main' sx={{ mt: 0.5 }}>
                              Service: {review.jobTypeName}
                            </Typography>
                          )}
                        </Box>
                        <Rating
                          value={review.rating || 5}
                          readOnly
                          size='small'
                        />
                      </Box>
                      <Typography variant='body1' sx={{ mt: 2 }}>
                        {review.review}
                      </Typography>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      ) : (
        <Box sx={{ textAlign: 'center', py: 8 }}>
          <Star sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
          <Typography variant='h6' color='text.secondary'>
            No reviews yet
          </Typography>
          <Typography variant='body2' color='text.secondary'>
            Be the first to leave a review!
          </Typography>
        </Box>
      )}

      <Box
        sx={{
          mt: 6,
          p: 3,
          bgcolor: 'background.paper',
          borderRadius: 2,
          border: '1px solid',
          borderColor: 'divider',
          textAlign: 'center',
        }}
      >
        <Typography variant='h6' gutterBottom>
          Had a great experience?
        </Typography>
        <Typography variant='body1' color='text.secondary'>
          We'd love to hear about it! Contact us to share your feedback.
        </Typography>
      </Box>
    </Container>
  )
}

export default Reviews
